import React from 'react'

interface LoadingProps {
    message?: string
    isDefault?: boolean
    setH?: string;
    setBgColor?: string;
    spinH?: string;
    fontSize?: string;
    spinColor?: string;
}

export default function Loading({ message, isDefault = true, setH, setBgColor, spinH, fontSize, spinColor = 'border-cbColor' }: LoadingProps) {
    return (
        <div className={`flex justify-center items-center ${isDefault ? 'h-64' : ''} ${setH?.length === 0 ? '' : setH}`}>
            <div className="flex items-center space-x-2">
                <div className={`${isDefault ? 'w-5 h-5' : ''} ${spinH} border-4 ${spinColor} border-t-transparent rounded-full animate-spin`}></div>
                {message?.length !== 0 && (<span className={`text-gray-600 font-medium ${fontSize}`}>{message}</span>)}
            </div>
        </div>
    )
}
